// El filtro «Ver» de la lista (04-11, mesas de equipo, web/qa/auditoria-apple/propuesta-2/fuentes/grupos.md §5): enseña
// solo un grupo (o el «Sin grupo» de una sala) con los MISMOS bloques y el MISMO orden de useEquipo — el filtro va encima,
// nunca reordena. Lo urgente que queda fuera no se esconde: la pastilla «N te espera(n) fuera · Alt ↓» (como lo que deja
// pasar un modo Concentración). PURO.
import type { ContratadoDTO, GrupoDTO, SalaDTO } from '../compartido/vocabulario';
import type { FiltroGrupo } from '../store';

export function enFiltro(c: Pick<ContratadoDTO, 'projectId' | 'grupoId'>, f: FiltroGrupo | null): boolean {
  return !f || (c.projectId === f.projectId && (c.grupoId ?? null) === f.grupoId);
}

export interface OpcionVer {
  grupoId: string | null;
  nombre: string;
  n: number;
  conSanti: boolean;
}

/**
 * Las opciones del menú «Ver», por sala: sus grupos con gente (en el orden de Pau) y su «Sin grupo», con cuántos de la
 * bandeja hay en cada uno. Solo las salas que tienen algún grupo con gente (sin grupos, filtrar por «Sin grupo» sería
 * «Todos»).
 */
export function opcionesVer(
  salas: readonly SalaDTO[],
  grupos: readonly GrupoDTO[],
  gente: readonly Pick<ContratadoDTO, 'projectId' | 'grupoId'>[],
  esperaSanti: (grupoId: string) => boolean,
): Array<{ sala: SalaDTO; opciones: OpcionVer[] }> {
  return salas
    .map((sala) => {
      const deSala = gente.filter((c) => c.projectId === sala.projectId);
      const conGente = grupos
        .filter((g) => g.projectId === sala.projectId)
        .sort((a, b) => a.orden - b.orden)
        .map((g) => ({ grupoId: g.id, nombre: g.nombre, n: deSala.filter((c) => c.grupoId === g.id).length, conSanti: esperaSanti(g.id) }))
        .filter((o) => o.n > 0);
      const sinGrupo = deSala.filter((c) => !c.grupoId).length;
      return { sala, opciones: conGente.length ? [...conGente, { grupoId: null, nombre: '', n: sinGrupo, conSanti: false }] : [] };
    })
    .filter((s) => s.opciones.length > 0);
}
